var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"lyrics"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }